var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
var UpgradeModalComponent = /** @class */ (function (_super) {
    __extends(UpgradeModalComponent, _super);
    function UpgradeModalComponent(dialogRef) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        return _this;
    }
    UpgradeModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return UpgradeModalComponent;
}(BaseComponent));
export { UpgradeModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/upgrade.modal/upgrade.modal.component.ts.pre-build-optimizer.js